import { render } from "./Alert.vue?vue&type=template&id=6ff21f4b&ts=true"
import script from "./Alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Alert.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/parts/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ff21f4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ff21f4b', __exports__)) {
    console.log('reload')
    api.reload('6ff21f4b', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=6ff21f4b&ts=true", () => {
    console.log('re-render')
    api.rerender('6ff21f4b', render)
  })

}


export default __exports__